export const CANVAS_ID = 'canvas_paint'
export const CANVAS_CURSOR = 'canvas_paint_cursor'
